/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmPictureFragment } from './CMPicture.fragment';
import { CmTaxonomy_CmLocTaxonomyImpl_Fragment, CmTaxonomy_CmTaxonomyImpl_Fragment, CmTaxonomy_SosLocationImpl_Fragment } from './CMTaxonomy.fragment';
import { gql } from '@apollo/client';
import { CmPictureFragmentDoc } from './CMPicture.fragment';
import { CmTaxonomyFragmentDoc } from './CMTaxonomy.fragment';
export type CmTeasableCommon_CmArticleImpl_Fragment = { __typename?: 'CMArticleImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmAudioImpl_Fragment = { __typename?: 'CMAudioImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmChannelImpl_Fragment = { __typename?: 'CMChannelImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmCollectionImpl_Fragment = { __typename?: 'CMCollectionImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmDownloadImpl_Fragment = { __typename?: 'CMDownloadImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmDynamicListImpl_Fragment = { __typename?: 'CMDynamicListImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmExternalLinkImpl_Fragment = { __typename?: 'CMExternalLinkImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmGalleryImpl_Fragment = { __typename?: 'CMGalleryImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmhtmlImpl_Fragment = { __typename?: 'CMHTMLImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmImageMapImpl_Fragment = { __typename?: 'CMImageMapImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmInteractiveImpl_Fragment = { __typename?: 'CMInteractiveImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmLocTaxonomyImpl_Fragment = { __typename?: 'CMLocTaxonomyImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmMediaImpl_Fragment = { __typename?: 'CMMediaImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmNavigationImpl_Fragment = { __typename?: 'CMNavigationImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmPersonImpl_Fragment = { __typename?: 'CMPersonImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmPictureImpl_Fragment = { __typename?: 'CMPictureImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmPlaceholderImpl_Fragment = { __typename?: 'CMPlaceholderImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmProductImpl_Fragment = { __typename?: 'CMProductImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmQueryListImpl_Fragment = { __typename?: 'CMQueryListImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmSelectionRulesImpl_Fragment = { __typename?: 'CMSelectionRulesImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmSpinnerImpl_Fragment = { __typename?: 'CMSpinnerImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmTaxonomyImpl_Fragment = { __typename?: 'CMTaxonomyImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmTeasableImpl_Fragment = { __typename?: 'CMTeasableImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmTeaserImpl_Fragment = { __typename?: 'CMTeaserImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmVideoImpl_Fragment = { __typename?: 'CMVideoImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_CmVisualImpl_Fragment = { __typename?: 'CMVisualImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_FormEditorImpl_Fragment = { __typename?: 'FormEditorImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment = { __typename?: 'SOSAmountIncreaseFormImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosAuthorImpl_Fragment = { __typename?: 'SOSAuthorImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosChartImpl_Fragment = { __typename?: 'SOSChartImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosContactImpl_Fragment = { __typename?: 'SOSContactImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosDonationCardImpl_Fragment = { __typename?: 'SOSDonationCardImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosDonationCertificateImpl_Fragment = { __typename?: 'SOSDonationCertificateImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosDonationFormImpl_Fragment = { __typename?: 'SOSDonationFormImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosDonationProductImpl_Fragment = { __typename?: 'SOSDonationProductImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosDonationProgressImpl_Fragment = { __typename?: 'SOSDonationProgressImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosDonationToolImpl_Fragment = { __typename?: 'SOSDonationToolImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosEventImpl_Fragment = { __typename?: 'SOSEventImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosFilterTeaserImpl_Fragment = { __typename?: 'SOSFilterTeaserImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosInternalLinkImpl_Fragment = { __typename?: 'SOSInternalLinkImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosJobTeaserImpl_Fragment = { __typename?: 'SOSJobTeaserImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosLocationImpl_Fragment = { __typename?: 'SOSLocationImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosNewsImpl_Fragment = { __typename?: 'SOSNewsImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosNotificationImpl_Fragment = { __typename?: 'SOSNotificationImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosOfferImpl_Fragment = { __typename?: 'SOSOfferImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosOrderFormImpl_Fragment = { __typename?: 'SOSOrderFormImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosOrganisationImpl_Fragment = { __typename?: 'SOSOrganisationImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosOverlayImpl_Fragment = { __typename?: 'SOSOverlayImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosPressreleaseImpl_Fragment = { __typename?: 'SOSPressreleaseImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosPublicationImpl_Fragment = { __typename?: 'SOSPublicationImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosRedirectPageImpl_Fragment = { __typename?: 'SOSRedirectPageImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment = { __typename?: 'SOSSpecialTopicCategoryImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosSpecialTopicImpl_Fragment = { __typename?: 'SOSSpecialTopicImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosTeaserImpl_Fragment = { __typename?: 'SOSTeaserImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosTextfragmentImpl_Fragment = { __typename?: 'SOSTextfragmentImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosTooltipImpl_Fragment = { __typename?: 'SOSTooltipImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_SosWimmelbildImpl_Fragment = { __typename?: 'SOSWimmelbildImpl', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommon_ViewTypeHeroCollection_Fragment = { __typename?: 'ViewTypeHeroCollection', id: string, type: string, viewtype?: string | null, title?: string | null, robots?: boolean | null, canonicalUrl?: string | null, selfUrl?: string | null, teaserTitle?: string | null, keywords?: string | null, responsiveSettings?: any | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, locationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null };

export type CmTeasableCommonFragment = CmTeasableCommon_CmArticleImpl_Fragment | CmTeasableCommon_CmAudioImpl_Fragment | CmTeasableCommon_CmChannelImpl_Fragment | CmTeasableCommon_CmCollectionImpl_Fragment | CmTeasableCommon_CmDownloadImpl_Fragment | CmTeasableCommon_CmDynamicListImpl_Fragment | CmTeasableCommon_CmExternalLinkImpl_Fragment | CmTeasableCommon_CmGalleryImpl_Fragment | CmTeasableCommon_CmhtmlImpl_Fragment | CmTeasableCommon_CmImageMapImpl_Fragment | CmTeasableCommon_CmInteractiveImpl_Fragment | CmTeasableCommon_CmLocTaxonomyImpl_Fragment | CmTeasableCommon_CmMediaImpl_Fragment | CmTeasableCommon_CmNavigationImpl_Fragment | CmTeasableCommon_CmPersonImpl_Fragment | CmTeasableCommon_CmPictureImpl_Fragment | CmTeasableCommon_CmPlaceholderImpl_Fragment | CmTeasableCommon_CmProductImpl_Fragment | CmTeasableCommon_CmQueryListImpl_Fragment | CmTeasableCommon_CmSelectionRulesImpl_Fragment | CmTeasableCommon_CmSpinnerImpl_Fragment | CmTeasableCommon_CmTaxonomyImpl_Fragment | CmTeasableCommon_CmTeasableImpl_Fragment | CmTeasableCommon_CmTeaserImpl_Fragment | CmTeasableCommon_CmVideoImpl_Fragment | CmTeasableCommon_CmVisualImpl_Fragment | CmTeasableCommon_FormEditorImpl_Fragment | CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment | CmTeasableCommon_SosAuthorImpl_Fragment | CmTeasableCommon_SosChartImpl_Fragment | CmTeasableCommon_SosContactImpl_Fragment | CmTeasableCommon_SosDonationCardImpl_Fragment | CmTeasableCommon_SosDonationCertificateImpl_Fragment | CmTeasableCommon_SosDonationFormImpl_Fragment | CmTeasableCommon_SosDonationProductImpl_Fragment | CmTeasableCommon_SosDonationProgressImpl_Fragment | CmTeasableCommon_SosDonationToolImpl_Fragment | CmTeasableCommon_SosEventImpl_Fragment | CmTeasableCommon_SosFilterTeaserImpl_Fragment | CmTeasableCommon_SosInternalLinkImpl_Fragment | CmTeasableCommon_SosJobTeaserImpl_Fragment | CmTeasableCommon_SosLocationImpl_Fragment | CmTeasableCommon_SosNewsImpl_Fragment | CmTeasableCommon_SosNotificationImpl_Fragment | CmTeasableCommon_SosOfferImpl_Fragment | CmTeasableCommon_SosOrderFormImpl_Fragment | CmTeasableCommon_SosOrganisationImpl_Fragment | CmTeasableCommon_SosOverlayImpl_Fragment | CmTeasableCommon_SosPressreleaseImpl_Fragment | CmTeasableCommon_SosPublicationImpl_Fragment | CmTeasableCommon_SosRedirectPageImpl_Fragment | CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment | CmTeasableCommon_SosSpecialTopicImpl_Fragment | CmTeasableCommon_SosTeaserImpl_Fragment | CmTeasableCommon_SosTextfragmentImpl_Fragment | CmTeasableCommon_SosTooltipImpl_Fragment | CmTeasableCommon_SosWimmelbildImpl_Fragment | CmTeasableCommon_ViewTypeHeroCollection_Fragment;

export const CmTeasableCommonFragmentDoc = gql`
    fragment CMTeasableCommon on CMTeasable {
  id
  type
  viewtype
  title
  robots
  canonicalUrl
  selfUrl
  detailText {
    textAsTree
  }
  teaserTitle
  teaserText {
    textAsTree
  }
  picture {
    ...CMPicture
  }
  subjectTaxonomy {
    ...CMTaxonomy
  }
  locationTaxonomy {
    ...CMTaxonomy
  }
  keywords
  responsiveSettings: settings(
    paths: ["responsiveViewXs", "responsiveViewSm", "responsiveViewMd", "responsiveViewLg", "responsiveViewXl"]
  )
}
    ${CmPictureFragmentDoc}
${CmTaxonomyFragmentDoc}`;